export class PanchangamJson {
    gotras: Array<string>;
    nakshathra: Array<string>;
    panEvent: Array<PanEventJson>;
    rasi: Array<string>;
    thithi: Array<string>;
    week: Array<string>;
    year: Array<string>;
}
export class PanEventJson {
    public tithi: { start, end, enMalayalam, mlMalayalam,id };
    public star: { start, end, enMalayalam, mlMalayalam };
    public secondStar: { start, end, enMalayalam, mlMalayalam };
    public secondTithi: { start, end, enMalayalam, mlMalayalam };
    public selected = false;
    public mlDay?: number;
    public mlMasa?: number;
    public mlFullYear?: number;
    public mlWeekday?: number;
    public weekNumber?: number;
    public mlDetails?: any;
    public pradosham?: any;
    constructor(public date?: number,
        public nakshathra?: string,
        public thithi?: string,
        public week?: string,
        public year?: string,
        public enNakshathra?: string,
        public enThithi?: string,
        public enWeek?: string,
        public enYear?: string) { }
    setMlData(option: { date: number, month: number, year: number, weekday: number, week: number }) {

        this.mlDay = option.date;
        this.mlMasa = option.month;
        this.mlFullYear = option.year;
        this.mlWeekday = option.weekday;
        this.weekNumber = option.week;

    }
    setMalyalamDetails(mlDetails) {
        this.mlDetails = mlDetails;
    }
}
